import React, { Component, Fragment } from "react";
import classnames from "classnames";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { updateKyc } from "../../../actions/updatePersionalDataKycActions";
import { withRouter,Link } from "react-router-dom";
import { toast } from 'react-toastify';
import ReactDatatable from '@ashvin27/react-datatable';
import $ from 'jquery';
import Moment from 'moment';
import axios from "axios";
import 'react-toastify/dist/ReactToastify.css';
import * as myConstList from '../../../BaseUrl';
const jwtToken = localStorage.getItem("jwtToken");
const baseUrl = myConstList.baseUrl;
const capitalizeFunc = myConstList.capitalize;
const configToken = {
    headers: {
      Authorization: 'Bearer '+`${localStorage.getItem("jwtToken")}`,
    },
  };
class ProfileUpdateEmail extends React.Component {

    constructor(props) {
        super(props);
        
        this.state = {
            id: this.props.id,
            records: [],
            email: '',
            currency: '',
            walletAddress:'',
            remarks:'',
            message:'',
            showResults : false,
            urltemp:'',
            errors: {}
        };

        this.columns = [
            {
              key: "_id",
              text: "Id",
              className: "id",
              align: "left",
              sortable: true,
              cell:(row,index)=>index+1
            },
            {   
                key:"exw",
                text:"Wallet Id",
                className: "amount",
                align: "left",
                sortable: true
            },
            {
                key: "wad",
                text: "Wallet Address",
                className: "txStatus",
                align: "left",
                sortable: true,
            },
            {
                key: "con",
                text: "Currency",
                className: "Currency",
                align: "left",
                sortable: true,
            },
          
        ];

        this.config = {
            page_size: 10,
            length_menu: [10, 20, 50],
            filename: "Fund Request List",
            no_data_text: 'No user found!',
            button: {

                print: true,
                csv: true
            },
            language: {
                length_menu: "Show _MENU_ result per page",
                filter: "Filter in records...",
                info: "Showing _START_ to _END_ of _TOTAL_ records",
                pagination: {
                    first: "First",
                    previous: "Previous",
                    next: "Next",
                    last: "Last"
                }
            },
            show_length_menu: true,
            show_filter: true,
            show_pagination: true,
            show_info: true,
        };
        this.getData = this.getData5.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        
        if (nextProps.errors) {
            this.setState({
                errors: nextProps.errors
            });
        }
        if (nextProps.prodata !== undefined
            && nextProps.prodata.pro !== undefined
            && nextProps.prodata.pro.data !== undefined
            && nextProps.prodata.pro.data.message !== undefined
            && nextProps.prodata.pro.data.status && nextProps.prodata.pro.data.messageStatus=='2') {            
                this.setState({
                    message: nextProps.prodata.pro.data.message,               
                    errors: {                   
                    },
                    currency: '',
                    walletAddress:'',
                    remarks:'',
                    error: "",         
                });
            this.getData5()
        }else if (nextProps.prodata !== undefined
            && nextProps.prodata.pro !== undefined
            && nextProps.prodata.pro.data !== undefined){
            this.setState({
                errors: nextProps.prodata.pro.data
            });
        }
    }

    componentDidMount(){
        if(localStorage.getItem("source") !== "" && localStorage.getItem("theme") !== ""){
            const urltemp = "?source="+localStorage.getItem("source")+"&theme="+localStorage.getItem("theme");
            this.setState({urltemp:urltemp});
        }
        this.getData5()
    }
    getData5() {
        const { user } = this.props.auth;
        axios
            .post(baseUrl+"api/wallet-address-data",{},configToken)
            .then(res => {
                this.setState({ records: res.data.data.fil})

                // window.webengage.track('Virtual Trading_Wallet Address Viewed', {
                //     'Currency Name':res.data.data.fil[0].con,
                //     'Wallet Address':res.data.data.fil[0].wad
                // });
            })
            .catch()
    }
    onChange = e => {
        this.setState({
            message: "",
            errors: {
                email: ""
            }
        })
        
        if (e.target.id === 'user-update-email') {
            this.setState({ email: e.target.value });
        } 
        if (e.target.id === 'user-update-walletAddress') {
            this.setState({ walletAddress: e.target.value,showResults: true });
            
        } 
        if (e.target.id === 'user-update-currency') {
            this.setState({ currency: e.target.value,showResults: true });
            
        } 
        if (e.target.id === 'user-update-remarks') {
            this.setState({ remarks: e.target.value,showResults: true });
            
        }         
    };
    
    
   
    onUserUpdate = e => {      
        e.preventDefault();
        if(this.state.currency === undefined || this.state.currency === ""){
            this.setState({ error: "Please enter currency" });
            return false;
        }
        if(this.state.walletAddress === undefined || this.state.walletAddress === ""){
            this.setState({ error: "Please enter wallet address" });
            return false;
        }
        // if(this.state.remarks === undefined || this.state.remarks === ""){
        //     this.setState({ error: "Please enter wallet remarks" });
        //     return false;
        // }
        
        const newUser = {
            _id: this.state.id,
             type:"email",
             email: this.state.email,
             walletAddress:this.state.walletAddress,
             currency:this.state.currency,
             remarks:this.state.remarks,
             };
             
        window.webengage.track('Virtual Trading_Wallet Address Saved', {
            'Currency Name':this.state.currency,
            'Wallet Address':this.state.walletAddress
        });

        this.props.updateKyc(newUser);
      
    };
    pageChange(pageData) {
        // console.log("OnPageChange", pageData);
    }
    render() {
        const { errors } = this.state;
        return (
            <div className="container container2">
                <div className="white_box">
                <form noValidate onSubmit={this.onUserUpdate}  id="update-user">
                    <span className="text-success">{this.state.message}</span>
                    <span className="text-danger">{this.state.error}</span>
                    <div className="row">
                        <input onChange={this.onChange} value={this.state.id} id="user-update-id" type="text" className="d-none"/>
                       
                        <div className="form-group col-md-12 col-12">
                            <label>Currency Name<span className="text-danger">*</span></label>
                            <input onChange={this.onChange} value={this.state.currency}
                                id="user-update-currency"
                                type="text" className="form-control"

                            />
                            <span className="text-danger">{errors.currency}</span>
                        </div>
                        <div className="form-group col-md-12 col-12">
                            <label>Wallet Address<span className="text-danger">*</span></label>
                            <input onChange={this.onChange}    value={this.state.walletAddress}
                                id="user-update-walletAddress"
                                type="text" className="form-control"

                            />
                            <span className="text-danger">{errors.walletAddress}</span>
                        </div>
                        <div className="form-group col-md-12 col-12">
                            <label>Remarks</label>
                            <input onChange={this.onChange}    value={this.state.remarks}
                                id="user-update-remarks"
                                type="text" className="form-control"

                            />
                            <span className="text-danger">{errors.remarks}</span>
                        </div>
                
                        <div className="form-group col-md-4">
                            <button className="btn btn_man mr-3">Save</button>
                            <a className="btn btn_man" href={this.state.urltemp!==""?"/dashboard"+this.state.urltemp:"/"}>Close</a>
                        </div>
                    </div>
                </form>
                </div>
                <div className="white_box">
                <h5 class=" mb-3">Wallet List</h5>
                    <div className="ccrool_table" >
                    
                                <ReactDatatable
                        config={this.config}
                        records={this.state.records}
                        columns={this.columns}
                        onPageChange={this.pageChange.bind(this)}
                    />
                    </div> 
                </div>
            </div>
            
        )
    }
}

ProfileUpdateEmail.propTypes = {
    updateKyc: PropTypes.func.isRequired,
    auth: PropTypes.object.isRequired,
    prodata: PropTypes.object.isRequired,
    errors: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
    auth: state.auth,
    prodata: state.prodata,
    errors: state.errors
});

export default connect(
    mapStateToProps,
    { updateKyc }
)(withRouter(ProfileUpdateEmail));
